import { ContentReducerCreator } from './types';
import loadProductsReducer from './reducers/load-products-reducer';
import deleteProductReducer from './reducers/delete-product-reducer';
import promoteProductReducer from './reducers/promote-product-reducer';
import updateProductReducer from './reducers/update-product-reducer';
import loadDocumentsReducer from './reducers/load-documents-reducer';
import loadUploadedVideosReducer from './reducers/load-uploaded-videos-reducer';
import loadRecordingssReducer from './reducers/load-recordings-reducer';
import loadPendingDownloadsReducer from './reducers/load-pending-downloads-reducer';
import setViewTypeReducer from './reducers/set-view-type-reducer';
import setSearchReducer from './reducers/set-search-reducer';
import setSortByReducer from './reducers/set-sort-by-reducer';
import updateContentMarkedForDeletionReducer from './reducers/update-content-marked-for-deletion-reducer';
import updateContentMarkedForDeletionAllReducer from './reducers/update-content-marked-for-deletion-all-reducer';
import exitEditingReducer from './reducers/exit-editing-reducer';
import setSelectedFileTypeReducer from './reducers/set-selected-file-type-reducer';
import setContentTypeToAddReducer from './reducers/set-content-type-to-add-reducer';
import setPageNumberReducer from './reducers/set-page-number-reducer';
import setProjectsFilterReducer from './reducers/set-projects-filter-reducer';
import setProductAttributesFilterReducer from './reducers/set-product-attributes-filter-reducer';
import setCurrentContentReducer from './reducers/set-current-content-reducer';
import createUploadJobReducer from './reducers/create-upload-job-reducer';
import updateUploadJobReducer from './reducers/update-upload-job-reducer';
import finishUploadJobReducer from './reducers/finish-upload-job-reducer';
import clearUploadedVideosReducer from './reducers/clear-uploaded-videos-reducer';
import clearRecordingsReducer from './reducers/clear-recordings-reducer';
import clearUploadedJobsReducer from './reducers/clear-upload-jobs-reducer';
import loadTemplatesReducer from './reducers/load-templates-reducer';
import loadFontsReducer from './reducers/load-fonts-reducer';
import loadThemePacksReducer from './reducers/load-theme-packs-reducer';
import deleteDocumentsReducer from './reducers/delete-documents-reducer';
import deleteRecordingReducer from './reducers/delete-recording-reducer';
import deleteUploadedVideoReducer from './reducers/delete-uploaded-video-reducer';
import deleteThemePackReducer from './reducers/delete-theme-pack-reducer';
import editUploadedVideoReducer from './reducers/edit-uploaded-video-reducer';
import addUploadedVideo from './reducers/add-uploaded-video';
import videoConversionUpdate from './reducers/video-conversion-update';

export const reducers = (create: ContentReducerCreator) => ({
  loadProducts: loadProductsReducer(create),
  deleteProduct: deleteProductReducer(create),
  promoteProduct: promoteProductReducer(create),
  updateProduct: updateProductReducer(create),
  loadDocuments: loadDocumentsReducer(create),
  loadUploadedVideos: loadUploadedVideosReducer(create),
  loadRecordings: loadRecordingssReducer(create),
  loadPendingDownloads: loadPendingDownloadsReducer(create),
  setViewType: setViewTypeReducer(create),
  setSearch: setSearchReducer(create),
  setSortBy: setSortByReducer(create),
  updateContentMarkedForDeletion: updateContentMarkedForDeletionReducer(create),
  updateContentMarkedForDeletionAll: updateContentMarkedForDeletionAllReducer(create),
  exitEditing: exitEditingReducer(create),
  setSelectedFileType: setSelectedFileTypeReducer(create),
  setContentTypeToAdd: setContentTypeToAddReducer(create),
  setPageNumber: setPageNumberReducer(create),
  setProjectsFilter: setProjectsFilterReducer(create),
  setProductAttributesFilter: setProductAttributesFilterReducer(create),
  setCurrentContent: setCurrentContentReducer(create),
  createUploadJob: createUploadJobReducer(create),
  updateUploadJob: updateUploadJobReducer(create),
  finishUploadJob: finishUploadJobReducer(create),
  clearUploadedVideos: clearUploadedVideosReducer(create),
  clearRecordings: clearRecordingsReducer(create),
  clearUploadJobs: clearUploadedJobsReducer(create),
  loadTemplates: loadTemplatesReducer(create),
  loadFonts: loadFontsReducer(create),
  loadThemePacks: loadThemePacksReducer(create),
  deleteDocuments: deleteDocumentsReducer(create),
  deleteRecording: deleteRecordingReducer(create),
  deleteUploadedVideo: deleteUploadedVideoReducer(create),
  deleteThemePack: deleteThemePackReducer(create),
  editUploadedVideo: editUploadedVideoReducer(create),
  addUploadedVideo: addUploadedVideo(create),
  videoConversionUpdate: videoConversionUpdate(create),
});
